import { useContext, useEffect, useState } from 'react';
import './SetasYPorros.scss';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../../js/api';
import Button from '../../../../components/Button/Button';
import { UserContext } from '../../../../js/UserContext';
import Modal from '../../../../components/Modal/Modal';

export default function SetasYPorros() {

    const [roomData, setRoomData] = useState(null);
    const { roomNumber } = useParams();
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);
    const [numSetas, setNumSetas] = useState(1);
    const { user, loading } = useContext(UserContext);
    const [isPorro, setIsPorro] = useState(null);

    const [error, setError] = useState(null);


    const fetchRoomData = async () => {
        try {
            const res = await api.get(`/rooms/${roomNumber}`, { silent: true });
            if (res && res.error) {
                console.error('Error fetching room data:', res.error);
                setError(res.error);
                return;
            }

            if (res.game && res.game.toLowerCase() !== 'setasyporros') {
                alert('This room is not for Setas y Porros game.');
                return navigate('/misc/minigames/setasyporros', { replace: true });
            }

            if (!res.users || !res.users.includes(user.login)) {
                const confirmJoin = window.confirm(`You are not in this room. Do you want to join?`);
                if (!confirmJoin) {
                    navigate('/misc/minigames/setasyporros', { replace: true });
                    return;
                }

                const joinRes = await api.post(`/users/${user.login}/rooms/${roomNumber}`, {}, { silent: true });
                if (joinRes && joinRes.error) {
                    console.error('Error joining room:', joinRes.error);
                    alert(joinRes.error ? joinRes.error : 'An error occurred while joining the room.');
                    navigate('/misc/minigames/setasyporros', { replace: true });
                    return;
                }
            }

            setRoomData(res);
            setIsAdmin(res.admin === user.login);
        } catch (error) {
            console.error('Error fetching room data:', error);
            alert('An error occurred while fetching the room data.');
        }
    }

    const porroOrSeta = async () => {
        if (isPorro !== null) {
            return isPorro;
        }
        const path = `/users/${user.login}/rooms/${roomNumber}/seta-porro`;
        const res = await api.get(path, { silent: true });
        console.log('path used:', path);
        console.log('Fetched Porro or Seta status:', res);
        if (res && res.error) {
            console.error('Error fetching Porro or Seta status:', res.error);
            alert('An error occurred while checking your status.');
            return;
        }

        if (res && typeof res.is_seta === 'boolean') {
            setIsPorro(!res.is_seta);
            return !res.is_seta;
        }

        alert('Could not determine if you are Porro or Seta.');
        return;
    }
    
    useEffect(() => {
        fetchRoomData();
    }, [roomNumber, user.login]);

    return (
        <div id="setasyporros">
            <div className="centered-container">
                {error ? (
                    <div className="error-message">
                        <h2>Error</h2>
                        <p>{error}</p>
                    </div>
                ) : roomData ? (
                    <div>
                        <div className="room-info">
                            <h2>Room: {roomData.name}</h2>
                            <p>Admin: {roomData.admin}</p>
                            <p>Private: {roomData.is_private ? 'Yes' : 'No'}</p>
                            <p>Created at: {roomData.created_at}</p>
                        </div>
                        <i></i>
                        <p className='margin-top'>Users: {roomData.users.length}</p>
                        <div>
                            <h3 className='margin-top'>Players in Room:</h3>
                            <ul>
                                {roomData.users.map((user) => (
                                    <li key={user}>{user}</li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <label htmlFor="numSetas">Number of Setas:</label>
                            <input
                                type="number"
                                className="input margin-top"
                                id="numSetas"
                                value={numSetas}
                                onChange={(e) => setNumSetas(parseInt(e.target.value))}
                                min={1}
                                max={100}
                            />
                        </div>
                        {(isAdmin && isPorro === null) && (
                            <Button text="Start Game" style_={{ marginTop: '20px' }} onClick={async() => {
                                console.log('Starting Setas y Porros game with', numSetas, 'setas in room', roomNumber);
                                api.post('/setasyporros/start', { room: Number(roomNumber), setas: numSetas }, { silent: true }).then(async     (res) => {
                                    if (res && res.error) {
                                        console.error('Error starting Setas y Porros game:', res.error);
                                        return alert('Error starting game: ' + res.error);
                                    }

                                    alert('Setas y Porros game started successfully!');
                                    await porroOrSeta();
                                    fetchRoomData();
                                }).catch((error) => {
                                    console.error('Error starting Setas y Porros game:', error);
                                    alert('An error occurred while starting the game.');
                                });
                            }} />
                        )}

                        <Button text="Check if I'm Porro or Seta" style_={{ marginTop: '20px' }} onClick={async () => {
                            const porro = await porroOrSeta();
                            if (porro === undefined) {
                                return;
                            }
                            alert(`You are a ${porro ? 'Porro' : 'Seta'}!`);
                        }} />   

                    </div>
                ) : (
                    <p>Loading room data...</p>
                )}
            </div>
        </div>
    );
}